// import React from "react";
import { createContext } from "react";


export const CartContext = createContext();
